import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Space } from '../../Space/src/Space.js';
import modules_0b64ef5e from '../styles/Sheet.module.less.js';

/**
 * @description Sheet Footer component.
 *
 * @component
 * @example
 * ```jsx
 * <Sheet.Footer>content</Sheet>
 * ```
 */
const Footer = React.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_0b64ef5e);
    return (React.createElement(Space, { ref: ref, size: 12, justify: "stretch", className: cx(className, 'footer'), ...restProps }, children));
});
Footer.defaultProps = {};
Footer.displayName = 'Footer';

export { Footer };
//# sourceMappingURL=Footer.js.map
